import { FeaturePermission } from "./FeaturePermission";
import { t } from "@/plugins/i18n";

export interface GlobalStore {
  userFeaturePermissions: FeaturePermission[];
  
  incomingInvoiceFilter: {
    None: null;
    General: string;
    ProdPurchase: string;
    DiffTax: string;
  };
  fileType: {
    pdf: string;
    doc: string;
    docx: string;
    xls: string;
    xlsx: string;
    csv: string;
    xml: string;
  };
  itemState: {
    InEdit: string;
    SelectToRemove: string;
    ShowDetails: string;
    Selected: string;
  };
  flags: {
    IsCarSale: Flag;
    IsPostCalc: Flag;
    IsNewPostCalcType: Flag;
    IsShcPostCalcType: Flag;
    IsStockPostCalcType: Flag;
    IsCarRectItem: Flag;
  };
  tableName: {
    PayMode: string;
    Tax: string;
  };
}

const globalStore: GlobalStore = {
  userFeaturePermissions: [],
  incomingInvoiceFilter: {
    None: null,
    General: "general",
    ProdPurchase: "prod-purchase",
    DiffTax: "diff-tax"
  },
  fileType: {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    csv: "text/csv",
    xml: "application/xml",
  },
  itemState: {
    InEdit: "InEdit",
    SelectToRemove: "SelectToRemove",
    ShowDetails: "ShowDetails",
    Selected: "Selected",
  },
  flags: {
    IsCarSale: { flag: t("GJE"), tooltip: t("GepjarmuErtekesiteshezTartozik") },
    IsPostCalc: { flag: t("UTOK"), tooltip: t("UtokalkulaciobanSzerepel") },
    IsNewPostCalcType: { flag: "UGJ", tooltip: t("UjGepjarmuvesUtokalkulaciohozTartozik") },
    IsShcPostCalcType: { flag: "HGJ", tooltip: t("HasznaltGepjarmuvesUtokalkulaciohozTartozik") },
    IsStockPostCalcType: { flag: t("ELABE"), tooltip: t("KeszleterteketModositELABEBanSzerepel") },
    IsCarRectItem: { flag: "GJ HELYESB", tooltip: t("GepjarmuHelyesbitoTipusu") },
  },  
  tableName: {
    PayMode: "csgenpaymode",
    Tax: "csgentax",
  },

}

export interface Flag {
  flag: string;
  tooltip: string;
}

export default globalStore;